
import { Link } from "react-router-dom";

export const Logo = () => (
  <Link to="/" className="flex items-center">
    <img 
      src="/lovable-uploads/730412b9-a2ce-4275-8447-e36e2a80cca1.png" 
      alt="Offertio" 
      className="h-8 w-auto object-contain"
    />
  </Link>
);
